import {Payment} from '../../components/Payment/Payment';

import cls from './Order.module.scss'
export const Order = () => (
    <div className={cls.page}>
        <h2>Поздравляем, ваша анкета одобрена!</h2>
        <Payment/>
    </div>
)